<form [formGroup]="customFielsDataFrom" class="col-12">
  <div #contenedor class="categories" cdkDropListGroup>
    @for (
      customField of customerCustomFieldArr;
      track customField.id;
      let i = $index
    ) {
      <ng-container class="mt-4">
        <div
          class="categories-item col-10 col-sm-10 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListData]="{ item: customField, index: i }"
          (cdkDropListDropped)="drop($event)"
        >
          <div cdkDrag>
            <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
            <div
              class="d-flex gap-2 align-items-baseline justify-content-between"
            >
              <div
                class="d-inline-block text-1 align-top inner f-15 tracking-normal"
              >
                {{ customField?.name }}
              </div>
              @if (editdeletshow != false) {
                <div id="some-icon">
                  <i
                    class="fa fa-edit edit-icon mr-2"
                    (click)="editField(customField, i)"
                  ></i>

                  <i
                    class="far fa-trash-alt del-icon"
                    (click)="removeItem(customField, i, 'removeCustomField')"
                  ></i>
                </div>
              }
            </div>
            @if (
              customField?.field_type_id == 1 ||
              customField?.field_type_id == '1'
            ) {
              <div class="mt-2">
                <mat-form-field appearance="outline" floatLabel="always">
                  <input
                    matInput
                    type="text"
                    class="fs-2"
                    formControlName="value_{{ customField.id }}"
                  />
                </mat-form-field>
              </div>
            }
            @if (
              isNumberType(customField?.field_type_id)
            ) {
              <div class="mt-2">
                <mat-form-field appearance="outline" floatLabel="always">
                  <input
                    matInput
                    type="number"
                    step="any"
                    class="fs-2"
                    formControlName="value_{{ customField.id }}"
                  />
                </mat-form-field>
              </div>
            }
            @if (
              customField?.field_type_id == 2 ||
              customField?.field_type_id == '2'
            ) {
              <div class="text-3 d-flex gap-2 flex-wrap mt-2">
                @for (
                  customerCusVal of customField?.customer_custom_field_values;
                  track customerCusVal;
                  let j = $index
                ) {
                  <div>
                    <mat-checkbox
                      [value]="customerCusVal.value"
                      color="primary"
                      formControlName="value_{{
                        customerCusVal.customerCustomFieldId
                      }}_{{ customerCusVal.value }}"
                    >
                      {{ customerCusVal.value }}
                    </mat-checkbox>
                  </div>
                }
              </div>
            }
            @if (
              customField?.field_type_id == 6 ||
              customField?.field_type_id == '6'
            ) {
              <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="mt-2"
              >
                <input
                  matInput
                  type="text"
                  formControlName="value_{{ customField.id }}_color"
                  [value]="customField.value"
                />
                <input
                  matInput
                  class="p-0 position-absolute end-0 top-0 m-2 text-1"
                  [style.background]="customField.value"
                  formControlName="value_{{ customField.id }}_color"
                  [value]="customField.value"
                  style="width: 15px; height: 15px; margin-top: 12px !important"
                  type="color"
                  (change)="
                    onColorChange($event, 'value_' + customField.id + '_color')
                  "
                />
              </mat-form-field>
            }

            @if (
              customField?.field_type_id == 3 ||
              customField?.field_type_id == '3'
            ) {
              <div class="text-3 d-flex gap-2 flex-wrap mt-2 custom-date">
                <app-custom-date
                  formControlName="value_{{ customField.id }}_date"
                  dataType="4"
                  inputType="date"
                  fvalue="{{ customField.value }}"
                  class="w-100"
                >
                </app-custom-date>
              </div>
            }

            @if (
              customField?.field_type_id == 5 ||
              customField?.field_type_id == '5'
            ) {
              <div class="text-3 mt-2">
                <mat-form-field appearance="outline" floatLabel="always">
                  <mat-select
                    class="text-1"
                    (selectionChange)="
                      updateSelectChange(
                        $event,
                        'value_' + customField.id + '_dropdown'
                      )
                    "
                    value="{{ customField.value }}"
                  >
                    <mat-option class="text-1" [value]="null">
                      <span class="clear-option">
                        <mat-icon>close</mat-icon>
                        Clear
                      </span>
                    </mat-option>

                    @for (
                      customerCusVal of customField?.customer_custom_field_values;
                      track customerCusVal;
                      let j = $index
                    ) {
                      <mat-option
                        class="text-1"
                        value="{{ customerCusVal.value }}"
                      >
                        {{ customerCusVal.value }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
            @if (
              customField?.field_type_id == 4 ||
              customField?.field_type_id == '4'
            ) {
              <div class="text-3 d-flex gap-2 flex-wrap mt-2">
                <mat-radio-group
                  aria-labelledby="custom-radio-group-label"
                  formControlName="value_{{ customField.id }}_radio"
                  color="primary"
                  class="custom-radio-group"
                >
                  @for (
                    customerCusVal of customField?.customer_custom_field_values;
                    track customerCusVal;
                    let j = $index
                  ) {
                    <mat-radio-button
                      class="custom-radio-button"
                      [value]="customerCusVal.value"
                    >
                      {{ customerCusVal.value }}
                    </mat-radio-button>
                  }
                </mat-radio-group>
              </div>
            }
            @if (
              isFormulaType(customField?.field_type_id)
            ) {
              <div class="mt-2 formula-field-block">
                <mat-form-field appearance="outline" floatLabel="always" class="w-100">
                  <input
                    matInput
                    type="text"
                    [value]="('COMMON.Calculated on quote' | translate) + (customField?.unit_of_measure ? ' (' + customField.unit_of_measure + ')' : '')"
                    readonly
                  />
                </mat-form-field>
                @if (isFormulaApplyReady() && getFormulaControl(customField); as applyControl) {
                  <div class="formula-apply-row d-flex align-items-center justify-content-between">
                    <span class="text-3 fs-14 fw-500">{{ 'COMMON.Apply on quote' | translate }}</span>
                    <mat-slide-toggle
                      [formControl]="applyControl"
                      color="primary"
                    ></mat-slide-toggle>
                  </div>
                }
                @if (customField?.formula_copied) {
                  <div class="formula-copied-notice d-flex align-items-start mt-2 p-2 rounded border" data-testid="formula-copied-notice">
                    <i class="fas fa-info-circle me-2 mt-1 text-warning"></i>
                    <span class="text-1 fs-14">{{ (customField?.formula_copied_from === 'field' ? 'COMMON.Formula from field notice' : 'COMMON.Formula copied notice') | translate }}</span>
                  </div>
                }
                <small class="text-muted d-block mt-1 mb-2">
                  {{ 'COMMON.Formula field tip' | translate }}
                </small>
              </div>
            }
          </div>
        </div>
      </ng-container>
    }
  </div>
</form>
